<!-- 好店推荐 -->
<template>
<div class="good-shop" id="first-floor">
    <div class="iner-warp">
        <div class="grid-bg"></div>
        <div class="cont-row">
            <div class="flex-cont"><img class="title-ig" :src="require('./assets/good.png')" alt=""></div>
            <div class="cont"><a href="https://corp.yorkbbs.ca/ads" class="show-this" target="_blank">我要出现在这里</a></div>
        </div>
        <swiper :options="swiperOptions">
            <swiper-slide v-for="item in list1" :key="item.id">
                <div class="ig"><a :href="item.url" target="_blank"><img :src="item.coverImage|webpFormat(750)" alt=""></a></div>
                <div class="title"><a :href="item.url" target="_blank" :title="item.title">{{item.title}}</a></div>
                <div class="tag" v-if="item.extend2">
                    <!-- <span v-for="(tag,index) in item.tags" :key="index">{{tag}}</span> -->
                    <span>{{item.extend2}}</span>
                </div>
            
                <div class="reason">{{item.reason}}</div>
            </swiper-slide>
            
            <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
    </div>
    
    
</div>
</template>
<script>
import {getRandomItems} from '@/utils/utils'
export default {
    name:'GoodShop',
    data(){
        return {
             // 轮播图配置
            swiperOptions: {
                spaceBetween: 30,
                /* autoplay: {
                    delay: 5000,
                    stopOnLastSlide: false,
                    disableOnInteraction: false,
                }, */
                slidesPerView: 2,

                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                },
            },
            outbreakLoading:true,
            list:[
                {
                    title:'开学季手机计划/家庭网络 TtopBoutique',
                    tags:['上网电视','家庭网络','手机','手机计划'],
                    phone:'647-313-5766',
                    image:'https://media1.imgyb.xyz/media/v1/image/0c39c90679e8a310aae0d60f4382a5b7.jpeg/webp750',
                    url:'https://info.yorkbbs.ca/detail/tv/7cf2c5c2-0546-4daf-9edb-a67e4325ee07'
                },
                {
                    title:'Virgin Plus 手机，家庭网络返校优惠 $45 20GB',
                    tags:['手机计划','签约手机','家庭网络','手机'],
                    phone:'905-940-8886',
                    image:'https://media6.imgyb.xyz/media/v1/image/33ec6f2897be387141ab384c860c1e09.jpeg/webp750',
                    url:'https://forum.yorkbbs.ca/detail/3c6816ab-43e2-4e90-aef9-f08579bddfdd?topic=digital'
                },
                {
                    title:'通用数据分析师核心软件班',
                    tags:['数据分析','独家Coop项目','主流项目案例'],
                    phone:'416-665-1888',
                    image:'https://media3.imgyb.xyz/media/v1/image/64753b985c435f45f2ff845817ea699d.png/webp750',
                    url:'https://www.vicedu.com/classes/data_analyst/'
                },
            ],
            list1:[],
        }
    },
    
    created(){
        this.getList();
    },
    methods:{
        async getList(){
            //测试环境id 用 cc6f7e9e-8cc8-488f-99fd-233cb47f5187
            //正式环境id 用 32599431-01c8-4a40-be5d-b5db19244fd7
            let result = await this.$axios.post('/cms/v1/get/topic/post/detail',{"postId":"32599431-01c8-4a40-be5d-b5db19244fd7","cmsType":3})
            if(result.code == 0 ){
                var dataObj = result.data.property.topicNews1;
                let randResult = getRandomItems(dataObj,dataObj.length);
                this.list1 = randResult;
                
            }
        }
    }
}
</script>
<style lang="less" scoped>
.good-shop{
    background: #FB8B31; border-radius: 20px; padding: 15px; margin: 60px 0 30px ;
    .iner-warp{
        position: relative; background: #fff; border-radius: 20px; padding:40px 20px 10px;
        .grid-bg{
            position: absolute; left: 20px; right: 20px;  top: -12px; height: 35px; box-sizing: border-box; 
            background: url(https://media2.imgyb.xyz/media/v1/image/50b3d6bf6573e1681b5c2da3666aac8b.png) repeat-x;
        }
        .cont-row{margin-bottom: 22px;}
        .show-this{color: #FF4526; text-decoration: underline;}
    }
}
@media screen and (max-width:768px){
    .good-shop{margin:30px 0 ;
        .title-ig{height: 20px;}
    }
}
/deep/.swiper-container{
    padding-bottom: 37px;
    .swiper-wrapper{
        .ig{margin-bottom: 5px; overflow: hidden; border-radius: 4px; font-size: 0;box-sizing: border-box; border: 1px solid #eeeeee;
            a{position: relative; width:100%; display: block;
                &:after{ content:''; display: inline-block; padding-bottom: 45.7%; }
                img{position: absolute; left: 0; top: 0; width: 100%; height: 100%; object-fit: cover; }
            }
            a:hover{
                img{transform: scale(1.1); transition: all 200ms linear;}
            }
        }
        .title{font-size: 16px; line-height: 24px; font-weight: 400; margin-bottom: 10px; white-space: normal; overflow: hidden; text-overflow: ellipsis;
            a{ white-space: nowrap;text-overflow: ellipsis; overflow: hidden; display: block;}
            a:hover{color: #e43a3a;}
        }
        .tag{display: flex; margin-bottom: 10px; flex-wrap: wrap; font-size: 14px; line-height: 20px; height: 20px; overflow: hidden;
            span{color: #999; margin-right: 10px;}
        }
        .phone{font-size: 16px; line-height: 22px; color: #E43A3A; font-weight: 600;}
        .reason{font-size: 14px; line-height: 20px; color: #999;}
        
    }
    .swiper-pagination{
        .swiper-pagination-bullet-active{background: #FB8B31;}
    }
}

</style>